module.exports = __webpack_public_path__ + "img/img_21@2x.a30957ff.png";